import React from 'react'
import neocapLogo from '../../assets/images/neocap_logo.png'
import './Header.scss'

const Header = () => {
    return (
        <header className="instant-loans-header">
            <img src={neocapLogo} alt="Neocap" width={136} />
        </header>
    )
}

export default Header
